// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__goN-A","row":"styles_row__1cp3N"};